var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-college-selector" },
    [
      _vm.colleges && _vm.colleges.length > 0
        ? _c("yxt-tree", {
            ref: "cataTree",
            attrs: {
              data: _vm.colleges,
              props: _vm.defaultProps,
              "wrap-width": "100%",
              "node-key": "id",
            },
            on: { "node-click": _vm.handleNodeClick },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (ref) {
                    var node = ref.node
                    return _c("span", { staticClass: "ellipsis" }, [
                      _vm._v(_vm._s(node.label)),
                    ])
                  },
                },
              ],
              null,
              false,
              3112127319
            ),
          })
        : _c("yxt-empty", { staticClass: "mt20" }, [
            _vm._v("\n    暂无数据\n  "),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }